import React, { 
    useState, 
    useEffect } from 'react';
import {
    Alert,
    Modal,
    notification,
} from 'antd';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import BusinessContactForm from './BusinessContactForm';

const siteDomain = headerVars.siteDomain;

function BusinessServicesContactForm() {
    const siteDomain = headerVars.siteDomain;
    const [formMarkup, setFormMarkup] = useState(<></>);
    const captchaKey = "6LdmP8QkAAAAACX1XkPWEZ08HGoIkk1nClZiagMJ";

    useEffect(() => { 
        setTimeout( function(){
            setFormMarkup(
                <div className=''>
                    <GoogleReCaptchaProvider
                        reCaptchaKey={ captchaKey }>
                        <BusinessContactForm/>
                    </GoogleReCaptchaProvider>
                </div>
            );
        }, 1000 );
    }, []);

    return (
        <div className="business-form-container">
            { formMarkup }
        </div>
    )
}

export default BusinessServicesContactForm
